<script setup>
import EditInput from "@/components/global/inputs/EditInput.vue";
import { ref } from "vue";

const props = defineProps({
  packagePages: {
    type: [Number, String],
    required: true,
  },
  organisationId: {
    type: Number,
    required: true,
  },
});

const packagePages = ref(props.packagePages);

const updateUrl = `/admin/crm/organisations/${props.organisationId}/update-package-pages`;

const success = (value) => packagePages.value = value;
</script>

<template>
  <EditInput
    :url="updateUrl"
    :current-value="packagePages"
    :confirm-before-save="true"
    confirm-title="Update Package Pages"
    :confirm-text="`Are you sure you want to change the package pages from ${packagePages} to a new value?`"
    @success="success"
  >
    <strong>{{ packagePages }}</strong>
  </EditInput>
</template>
